import MuiPagination from '@mui/material/Pagination'
import Stack from '@mui/material/Stack'
import RowsPerPageMenu from './RowsPerPageMenu'
import { PaginationProps } from './types'

// `activePage`/`onPageClick` are EUI's 0-based pages; MUI's are 1-based.
export default function PaginationMui( { pageCount, activePage, onPageClick, itemsPerPage, setItemsPerPage }: PaginationProps ) {
	return (
		<Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap">
			<RowsPerPageMenu rowsPerPage={itemsPerPage} setRowsPerPage={setItemsPerPage} />
			<MuiPagination
				count={pageCount}
				page={activePage + 1}
				onChange={( _, page ) => onPageClick( page - 1 )}
			/>
		</Stack>
	)
}
